import createRoute from '@widesk-ui/tools/createRoute';

const route = createRoute.customFromService(
	`Paramétrage`,
	'/website_entertainments/:websiteEntertainmentId/website_configs/:categoryReference',
	'website',
	'WebsiteConfig',
);

export default route;
